<template>
  <div>
    <header-bar ref="headerBar" v-on:updateDrow="forceUpdate"/>
    <main>
      <div class="columns" style="margin: 0px;">
        <div class="column" style="background-color: white;">
          <router-view v-on:profileChanged="profileChanged"></router-view>
        </div>
      </div>
    </main>
    <go-to-top/>
  </div>
</template>

<script>
import Vue from "vue";
import Header from "@/components/mock/base/header";
Vue.component("header-bar", Header);
import GoToTop from "@/components/mock/base/pageTop";
Vue.component("go-to-top", GoToTop);

export default {
  name: "guestIndex",
  data() {
    return {
    };
  },
  methods: {
    forceUpdate(){
      this.$emit("forceUpdate");
    },
    profileChanged(){
      console.log("call ProfileChanged.")
      this.$refs.headerBar.redraw();
    },
  }
};
</script>
<style lang="scss" scoped>
</style>




// WEBPACK FOOTER //
// src/components/mock/guest/index.vue